import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=9c7e96e8&scoped=true"
import script from "./side-menu-item.vue?vue&type=script&lang=js"
export * from "./side-menu-item.vue?vue&type=script&lang=js"
import style0 from "./side-menu-item.vue?vue&type=style&index=0&id=9c7e96e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7e96e8",
  null
  
)

export default component.exports